import { makeAutoObservable } from 'mobx';

import { ApiRoutes } from '../../config/ApiRoutes';
import { RootStore } from '../index';

export class MvrApiStore {
  constructor(public rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  getMvr = (params: any) => {
    const {
      Get: { Endpoint, Method },
    } = ApiRoutes.Mvr;
    return this.rootStore.apiStore.call<any>({
      method: Method,
      params: params,
      url: Endpoint,
    });
  };

  addMvr = (data: any) => {
    const {
      Add: { Endpoint, Method },
    } = ApiRoutes.Mvr;
    return this.rootStore.apiStore.call<any>({
      data,
      method: Method,
      url: Endpoint,
    });
  };
}
